import React, { memo, useLayoutEffect } from 'react';
import {
    AwardsBlock,
    Footer,
    Header,
    CrewMembersBlock,
    PortfolioBlock,
    FAQsBlock,
    DegustationBlock,
    ImagesBlock,
    ContactsBlock,
    NavigationBlock,
    Breadcrumb,
    PlacesBlock,
    Toolbar,
} from 'widgets';
import { Error, PageLayout, useAppDispath } from 'shared';
import { CulinaryStudioPageMain } from './components';
import { CulinaryStudioPageActions, useCulinaryStudioPageState } from '../store';

const MemoBreadcrumb = memo(Breadcrumb);
const MemoFooter = memo(Footer);
const MemoAwardsBlock = memo(AwardsBlock);
const MemoPortfolioBlock = memo(PortfolioBlock);
const MemoPlacesBlock = memo(PlacesBlock);
const MemoFAQsBlock = memo(FAQsBlock);
const MemoDegustationBlock = memo(DegustationBlock);
const MemoImagesBlock = memo(ImagesBlock);
const MemoContactsBlock = memo(ContactsBlock);
const MemoNavigationBlock = memo(NavigationBlock);
const MemoMain = CulinaryStudioPageMain;

export const CulinaryStudioPage = () => {
    const dispatch = useAppDispath();

    const {
        errors,
        title,
        description,
        image,
    } = useCulinaryStudioPageState();

    useLayoutEffect(() => {
        dispatch(CulinaryStudioPageActions.getCulinaryStudioService());
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, []);

    return (
        <PageLayout
            toolbar={<Toolbar />}
        >
            <Header />
            <MemoBreadcrumb />
            {errors.length === 0 ? (
                <MemoMain
                    title={title}
                    description={description}
                    image={image}
                />
            ) : (
                <Error
                    errors={errors}
                    margin="4rem 0"
                />
            )}
            <MemoAwardsBlock />
            <MemoImagesBlock />
            <MemoDegustationBlock />
            <CrewMembersBlock />
            <MemoPortfolioBlock />
            <MemoPlacesBlock />
            <MemoContactsBlock />
            <MemoFAQsBlock />
            <MemoNavigationBlock />
            <MemoFooter />
        </PageLayout>
    );
};
